const browserLocale = navigator.language.split('-')[0];
const currentLocale = window.localStorage.getItem("lang") || browserLocale
const language = currentLocale || 'en';
export const langDir = 'ltr';

export default language;
